import React, { Component } from "react";
import { Form, Button, Card, Nav, Tab, Row, Col } from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntroInsurance from "./HeaderIntroInsurance";
import BusinessRegistrationProcess from "./BusinessRegistrationProcess";
import NewsLetter from "./NewsLetter";
export class Insurance extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          <HeaderIntroInsurance />
        </div>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default Insurance;
